import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import axios from 'axios'
import { config } from '../../../config/index'
import { urlConstants } from '../../../constants/urlConstants'

export const AquisitionApi = createApi({
    reducerPath: 'AquisitionApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config().BASE_URL,
        prepareHeaders: (headers: any) => {
            headers.set("Authorization", `Token ${localStorage.getItem('cw-token')}`)
            return headers
        }
    }),
    tagTypes: ['aquisition', 'aquisition-dropdown'],
    endpoints: (builder) => ({
        createAcquisition: builder.mutation<any, any>({
            query: (acquisitionData: any) => ({
                url: urlConstants.AQUISITION,
                method: 'POST',
                body: acquisitionData
            }),
            invalidatesTags: ['aquisition']
        }),
        getAquisitionDropdownsDetails: builder.query<any, void>({
            query: () => ({
                url: urlConstants.AQUISITION_DROPDOWN,
                method: 'GET',
            }),
            providesTags: ['aquisition']
        }),
        getUserSalesDropdownsDetails: builder.query<any, void>({
            query: () => ({
                url: urlConstants.SALES_DROPDOWN,
                method: 'GET',
            }),
            providesTags: ['aquisition-dropdown']
        }),
        getAcquisitionList: builder.query<any, any>({
            query: ({ currentPage, startDate, endDate, svStatus, searchType, searchString,limit,project }: any) => {
                const params = {
                    page: currentPage,
                    limit:limit,
                    fromDate: startDate,
                    toDate: endDate,
                    project: project,
                    svStatus,
                    ...(searchType === 'customer' && { searchString }),
                    ...(searchType === 'fls' && { fls: searchString }),
                    ...(searchType === '' && { searchString }),
                };

                return {
                    url: urlConstants.AQUISITION_LIST,
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['aquisition']
        }),

        editAcquisition: builder.mutation<any, any>({
            query: ({ acquisitionData, id }: any) => ({
                url: `${urlConstants.CUSTOMER}/${id}`,
                method: 'PUT',
                body: acquisitionData
            }),
            invalidatesTags: ['aquisition']
        }),
        editAcquisitionSF: builder.mutation<any, any>({
            query: ({ acquisitionData, id }: any) => ({
                url: `${urlConstants.UPDATE_AQUISITOIN_SF}/${id}`,
                method: 'PUT',
                body: acquisitionData
            }),
            invalidatesTags: ['aquisition']
        }),
        getSingleCustomer: builder.query<any, { id: string }>({
            query: (id) => ({
                url: `${urlConstants.CUSTOMER}/${id}`,
                method: 'GET',
            }),
            providesTags: ['aquisition']
        }),
        deleteAcquisition: builder.mutation<any, any>({
            query: (id: any) => ({
                url: `${urlConstants.CUSTOMER}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['aquisition']
        }),
        assignFieldDropdownList: builder.query<any, any>({
            query: () => ({
                url: urlConstants.FIELD_EMPLOYEE_DROPDOWN,
                method: 'GET',
            }),
            providesTags: ['aquisition-dropdown']
        }),
        sendOtp: builder.mutation<any, any>({
            query: (phoneNumber: any) => ({
                url: urlConstants.SENDOTP,
                method: 'POST',
                body: { phoneNumber }
            })
        }),
        sendWhatsAppOtp: builder.mutation<any, { phoneNumber?: string; countryCode?: string; email?: string; customerName?: string }>({
            query: (payload) => ({
                url: urlConstants.SEND_WHATSAPP_OTP,
                method: 'POST',
                body: payload
            })
        }),
        validateOtp: builder.mutation<any, any>({
            query: ({ phoneNumber, email, otp }: any) => ({
                url: urlConstants.VALIDATEOTP,
                method: 'POST',
                body: { phoneNumber, email, otp }
            })
        }),
        getCustomerDuplicates: builder.query<any, any>({
            query: ({ id }: any) => ({
                url: `${urlConstants.DUPLICATES}/${id}`,
                method: 'GET',
            }),
        }),
        getAquisitionFormQuestions: builder.query<any, void>({
            query: () => ({
                url: urlConstants.ACQUISITION_FORM_QUESTION,
                method: 'GET',
            }),
            providesTags: ['aquisition']
        }),
        getCustomerBasicInfo: builder.query<any, { id: string }>({
            query: ({ id }) => ({
                url: `${urlConstants.CUSTOMER}/basicInfo`,
                method: 'GET',
                params: { id }
            }),
            providesTags: ['aquisition']
        }),
        addReview: builder.mutation<any, any>({
            query: (reviewData: any) => ({
                url: urlConstants.REVIEW_ADD,
                method: 'POST',
                body: reviewData
            }),
            invalidatesTags: ['aquisition']
        }),
        getExistingReview: builder.query<any, { id: string }>({
            query: ({ id }) => ({
                url: `${urlConstants.REVIEW_GET}?id=${id}`,
                method: 'GET',
            }),
            providesTags: ['aquisition']
        }),
        updateAdminRemarks: builder.mutation<any, { adminRemarkId: string; adminRemarks: string }>({
            query: ({ adminRemarkId, adminRemarks }) => ({
                url: `${urlConstants.ADMIN_REMARKS}/${adminRemarkId}`,
                method: 'PUT',
                body: { adminRemarks },
            }),
        }),
        sendWhatsAppFeedbackRequest: builder.mutation<any, { id: number }>({
            query: ({ id }) => ({
                url: `${urlConstants.CUSTOMER}${urlConstants.WHATSAPP_FEEDBACK_REQ}`,
                method: 'POST',
                body: { id }
            })
        }),
        getPincodeArea: builder.mutation<any, { pincode: string }>({
            query: ({ pincode }) => ({
                url: `${urlConstants.PINCODE_AREA}/${pincode}`,
                method: 'GET'
            })
        }),
        createBookedCustomer: builder.mutation<any, any>({
            query: (customerData: any) => ({
                url: urlConstants.ADD_BOOKED_CUSTOMER,
                method: 'POST',
                body: customerData
            }),
            invalidatesTags: ['aquisition']
        }),
        updateBookedCustomer: builder.mutation<any, { id: string, data: any }>({
            query: ({ id, data }) => ({
                url: `${urlConstants.UPDATE_BOOKED_CUSTOMER}/${id}`,
                method: 'PUT',
                body: data
            }),
            invalidatesTags: ['aquisition']
        }),
        getBookedCustomerListing: builder.query<any, any>({
            query: ({ page, project }: any) => ({
                url: urlConstants.BOOKED_CUSTOMER_LIST,
                method: 'GET',
                params: { page, projectId: project }
            }),
            providesTags: ['aquisition']
        }),
        getLeadByRefNo: builder.query<any, string>({
            query: (refNo) => ({
                url: `${urlConstants.GET_LEAD_BY_REF}/${refNo}`,
                method: 'GET'
            })
        }),
        getLeadTaskDetails: builder.mutation<any, { mobileNumber: string }>({
            query: ({ mobileNumber }) => ({
                url: urlConstants.TASK_DETAILS,
                method: 'POST',
                body: { mobileNumber }
            })
        }),
    })
})

export const {
    useCreateAcquisitionMutation,
    useLazyGetLeadByRefNoQuery,
    useGetAquisitionDropdownsDetailsQuery,
    useGetUserSalesDropdownsDetailsQuery,
    useEditAcquisitionSFMutation,
    useGetAcquisitionListQuery,
    useEditAcquisitionMutation,
    useGetSingleCustomerQuery,
    useDeleteAcquisitionMutation,
    useAssignFieldDropdownListQuery,
    useSendOtpMutation,
    useSendWhatsAppOtpMutation,
    useValidateOtpMutation,
    useGetCustomerDuplicatesQuery,
    useGetAquisitionFormQuestionsQuery,
    useGetCustomerBasicInfoQuery,
    useAddReviewMutation,
    useGetExistingReviewQuery,
    useUpdateAdminRemarksMutation,
    useSendWhatsAppFeedbackRequestMutation,
    useGetPincodeAreaMutation,
    useCreateBookedCustomerMutation,
    useUpdateBookedCustomerMutation,
    useGetBookedCustomerListingQuery,
    useGetLeadTaskDetailsMutation,
} = AquisitionApi

export const fetchLeadTaskDetails = async (mobileNumber: string): Promise<any> => {
    if (!mobileNumber) return null;
    const cleanPhone = String(mobileNumber).replace(/\D/g, "").slice(-10) || String(mobileNumber).trim();

    // 1. Direct call to Salesforce Production Apex REST API first as requested
    try {
        const directUrl = "https://casagrandbuilderprivatelimited.my.salesforce-sites.com/channelpartnersv/services/apexrest/lead/task-details";
        console.log(`[TaskDetails] Calling direct Salesforce Production API: ${directUrl} for phone: ${cleanPhone}`);
        const res: any = await axios.post(directUrl, { mobileNumber: cleanPhone }, {
            headers: { "Content-Type": "application/json" },
            timeout: 45000,
        });
        const data: any = res?.data;
        if (data && (data.success || data.data || data.statusCode === 200)) {
            console.log("[TaskDetails] Direct Salesforce call succeeded:", data);
            return data?.data || data;
        }
    } catch (directErr: any) {
        console.log("[TaskDetails] Direct Salesforce call error / fallback needed:", directErr?.message);
    }

    // 2. Fallback to GRE Portal Backend proxy endpoint /api/customer/task-details if direct call fails
    try {
        const backendUrl = `${config().BASE_URL}${urlConstants.TASK_DETAILS}`;
        console.log(`[TaskDetails] Calling backend proxy API: ${backendUrl} for phone: ${cleanPhone}`);
        const token = localStorage.getItem('cw-token');
        const res: any = await axios.post(backendUrl, { mobileNumber: cleanPhone }, {
            headers: {
                "Content-Type": "application/json",
                ...(token ? { "Authorization": `Token ${token}` } : {})
            },
            timeout: 45000,
        });
        const data: any = res?.data;
        if (data && (data.success || data.data || data.statusCode === 200)) {
            console.log("[TaskDetails] Backend proxy call succeeded:", data);
            return data?.data?.data || data?.data || data;
        }
    } catch (backendErr: any) {
        console.log("[TaskDetails] Backend proxy call failed:", backendErr?.message);
    }

    return null;
};

export const extractTaskDetailsPayload = (taskData: any) => {
    if (!taskData) return {};
    let d = taskData;
    while (d && d.data && typeof d.data === "object" && !d.WhoId && !d.Subject && !d.DL_Number) {
        d = d.data;
    }
    const fv = d?.fieldValues || {};
    return {
        dlNumber: d?.DL_Number || fv?.DL_Number__c || d?.dlNumber || null,
        dlProjectName: d?.DL_Project_Name || fv?.DL_Project_Name__c || d?.dlProjectName || null,
        dlPrimarySource: d?.DL_Primary_Source || fv?.DL_Primary_Source__c || d?.dlPrimarySource || null,
        dlSecondarySource: d?.DL_Secondary_Source || fv?.DL_Secondary_Source__c || d?.dlSecondarySource || null,
        dlTertiarySource: d?.DL_Tertial_Source || fv?.DL_Tertial_Source__c || d?.DL_Tertiary_Source || fv?.DL_Tertiary_Source__c || d?.dlTertiarySource || null,
        dlCreatedDate: d?.DL_Created_Date || fv?.DL_Created_Date__c || d?.dlCreatedDate || null,
        taskSubject: d?.Subject || fv?.Subject || d?.taskSubject || null,
        taskDueDate: d?.Due_Date || fv?.ActivityDate || d?.taskDueDate || null,
        taskCreatedBy: d?.CreatedBy_Name || d?.taskCreatedBy || null,
        taskLeadStatus: d?.Lead_Status || fv?.Lead_Stage__c || d?.taskLeadStatus || null,
        taskLeadOwner: d?.Lead_Owner || fv?.Lead_Owner__c || d?.taskLeadOwner || null,
        taskProjectInterested:
            d?.Project_Interested ||
            fv?.Project_Interested__c ||
            (Array.isArray(d?.Project_Interested_List) && d?.Project_Interested_List.length > 0
                ? d.Project_Interested_List.join(", ")
                : null) ||
            d?.taskProjectInterested ||
            null,
        hasSiteVisitScheduled: d?.hasSiteVisitScheduled ?? fv?.hasSiteVisitScheduled ?? null,
        taskWhoId: d?.WhoId || fv?.WhoId || d?.taskWhoId || null,
        taskOwnerId: d?.OwnerId || fv?.OwnerId || d?.taskOwnerId || null,
        taskActivitySubtype: d?.Activity_Subtype || fv?.Activity_Subtype__c || d?.taskActivitySubtype || null,
        rawTaskDetails: d,
    };
};
